import SymptomResultSection from '@/components/templates/mobile/home/home-search-template/components/home-disease-symptom-search/components/symptom-result-section';
import RecentKeyword from '@/components/templates/mobile/home/home-search-template/components/recent-keyword';
import { AdPageType } from '@/models/ad/list';
import { UnifiedAdBanner } from '@/shared/ui';
import { Client } from '@/types/app';
import { HomeSearchKeywordList } from '@/types/search';
import React from 'react';
import styled from 'styled-components';

type Props = {
  entryType?: string;
  popularSymptomList: Array<{
    symptomName: string;
    symptomPublicId: string;
  }>;
  recommendationKeyword: string;
  handleSymptomKeywordClick: (keyword: string) => void;
  handleSearchDirectKeyword: (keyword: string) => void;
  recentKeywordViewData: HomeSearchKeywordList;
  handleDeleteItemRecentKeyword: (keyword: string) => void;
  handleDeleteAllRecentKeyword: () => void;
  client: Client;
};

const HomeDiseaseSymptomSearch = (props: Props) => {
  const {
    entryType,
    popularSymptomList,
    recommendationKeyword,
    handleSymptomKeywordClick,
    handleSearchDirectKeyword,
    handleDeleteItemRecentKeyword,
    handleDeleteAllRecentKeyword,
    recentKeywordViewData,
    client,
  } = props;

  return (
    <section className={'flex flex-col gap-[16px] bg-white pt-[16px]'}>
      {entryType !== 'symptom' && recentKeywordViewData.length > 0 && (
        <RecentKeyword
          onSearchDirectKeyword={handleSearchDirectKeyword}
          recentKeywordViewData={recentKeywordViewData}
          onDeleteItemRecentKeyword={handleDeleteItemRecentKeyword}
          onDeleteAllRecentKeyword={handleDeleteAllRecentKeyword}
        />
      )}
      <UnifiedAdBanner
        className={'px-[24px]'}
        adPageType={AdPageType.Search}
        client={client}
        fallbackContent={null}
        borderRadius={8}
      />
      <SymptomResultSection title={'인기 검색어'}>
        <SymptomResultSection.Result>
          <PopularSearchSymptomKeywordContainer>
            <PopularSearchKeywordRecommendationKeyword
              key={'recommendationKeyword'}
              onClick={() => handleSymptomKeywordClick(recommendationKeyword)}
            >
              <PopularSearchKeywordRecommendationBadge>추천</PopularSearchKeywordRecommendationBadge>
              <PopularSearchKeywordAdWrapper>
                <PopularSearchSymptomKeywordContent>{recommendationKeyword}</PopularSearchSymptomKeywordContent>
                <PopularSearchKeywordAdBadge>AD</PopularSearchKeywordAdBadge>
              </PopularSearchKeywordAdWrapper>
            </PopularSearchKeywordRecommendationKeyword>
            {popularSymptomList.map((symptom: { symptomName: string; symptomPublicId: string }, index: number) => {
              return (
                <PopularSearchSymptomKeyword
                  key={symptom.symptomPublicId}
                  onClick={() => handleSymptomKeywordClick(symptom.symptomName)}
                >
                  <PopularSearchSymptomKeywordIndex>{index + 1}</PopularSearchSymptomKeywordIndex>
                  <PopularSearchSymptomKeywordContent>{symptom.symptomName}</PopularSearchSymptomKeywordContent>
                </PopularSearchSymptomKeyword>
              );
            })}
          </PopularSearchSymptomKeywordContainer>
        </SymptomResultSection.Result>
      </SymptomResultSection>
    </section>
  );
};

export default HomeDiseaseSymptomSearch;

const PopularSearchSymptomKeywordContainer = styled.div`
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 24px 16px;
  margin: 0;
`;

const PopularSearchSymptomKeyword = styled.button`
  border: none;
  width: 100%;
  padding: 8px 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
    gap: 8px;
`;

const PopularSearchKeywordRecommendationKeyword = styled.button`
  border: none;
  width: 100%;
  padding: 8px 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
`;

const PopularSearchSymptomKeywordIndex = styled.span`
  color: ${({ theme }) => theme.color.primary700};
  ${({ theme }) => theme.typography.UI15SB};
  display: flex;
  text-align: left;
  margin-left: 4px;
  width: 32px;
  height: 20px;
  align-items: center;
`;

const PopularSearchKeywordRecommendationBadge = styled.span`
    display: flex;
    width: 32px;
    height: 22px;
    padding: 0 3px;
    border-radius: 20px;
    justify-content: center;
    align-items: center;
    background-color: ${({ theme }) => theme.color.blue100};
    color: ${({ theme }) => theme.color.blue700};
    ${({ theme }) => theme.typography.UI13SB};
`;

const PopularSearchSymptomKeywordContent = styled.span`
  color: ${({ theme }) => theme.color.gray700};
  ${({ theme }) => theme.typography.UI17SB};
  display: inline-flex;
  align-items: center;
  height: 30px;
  text-align: left;
`;

const PopularSearchKeywordAdWrapper = styled.span`
    display: flex;
    gap: 8px;
`;

const PopularSearchKeywordAdBadge = styled.span`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.color.gray300};
  ${({ theme }) => theme.typography.UI13M};
`;
